import Link from "next/link";
import { useTranslation } from "next-i18next";
import "./styles/_mw-certified.module.scss";

/** Maps product templates using `AgentIntegration` + contact card to `contactUsCard.byProduct.*` keys */
export type ContactUsProductVariant =
    | "infra-monitoring"
    | "log-monitoring"
    | "rum-monitoring"
    | "apm-monitoring"
    | "synthetic-monitoring"
    | "llm-monitoring"
    | "database-monitoring"
    | "status-page";

const VARIANT_TO_I18N_KEY: Record<ContactUsProductVariant, string> = {
    "infra-monitoring": "contactUsCard.byProduct.infrastructureMonitoring",
    "log-monitoring": "contactUsCard.byProduct.logMonitoring",
    "rum-monitoring": "contactUsCard.byProduct.rumMonitoring",
    "apm-monitoring": "contactUsCard.byProduct.apmMonitoring",
    "synthetic-monitoring": "contactUsCard.byProduct.syntheticMonitoring",
    "llm-monitoring": "contactUsCard.byProduct.llmMonitoring",
    "database-monitoring": "contactUsCard.byProduct.databaseMonitoring",
    "status-page": "contactUsCard.byProduct.statusPage",
};

type Props = {
    /** When set, shows a product-specific headline instead of `contactUsCard.message` */
    variant?: ContactUsProductVariant;
};

const MwContactUs = ({ variant }: Props) => {
    const { t } = useTranslation("common");
    const message =
        variant != null && VARIANT_TO_I18N_KEY[variant] != null
            ? t(VARIANT_TO_I18N_KEY[variant])
            : t("contactUsCard.message");
    return (
        <>
            <section className={"mw-certified contact-us-card"}>
                <div className={"secure-mw gradient-border-bottom gradient-border-top"}>
                    <p>{message}</p>
                    <Link href={"/contact-us/"} className={"ahref-btn primary"}>
                        {t("contactUsCard.buttonText")}
                    </Link>
                </div>
            </section>
        </>
    );
};
export default MwContactUs;